"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkPageName = exports.checkBasicText = exports.CONTAINS_URL_ERROR = exports.CONTAINS_HTML_ERROR = exports.validateEmail = exports.validatePhoneNumber = exports.containsUrlOrEmail = exports.containsTemplateBraces = exports.containsHtml = void 0;
var linkify = __importStar(require("linkifyjs"));
var validator_1 = __importDefault(require("validator"));
var lodash_1 = require("lodash");
var containsHtml = function (str) {
    return str.includes("<") || str.includes(">");
};
exports.containsHtml = containsHtml;
var containsTemplateBraces = function (str) {
    return str.includes("{") || str.includes("}");
};
exports.containsTemplateBraces = containsTemplateBraces;
var containsUrlOrEmail = function (str) {
    var foundLinks = linkify.find(str);
    return foundLinks.length > 0;
};
exports.containsUrlOrEmail = containsUrlOrEmail;
var validatePhoneNumber = function (str) {
    return validator_1.default.isMobilePhone(str, "any") || !str.length;
};
exports.validatePhoneNumber = validatePhoneNumber;
var validateEmail = function (str) {
    return validator_1.default.isEmail(str);
};
exports.validateEmail = validateEmail;
exports.CONTAINS_HTML_ERROR = "cannot contain the symbols > or <";
exports.CONTAINS_URL_ERROR = "cannot contain emails or URLs";
var checkBasicText = function (str, config) {
    if (config === void 0) { config = {}; }
    if (!(0, lodash_1.isString)(str)) {
        return { valid: false, error: "must be a string" };
    }
    if (!config.allowUrlsOrEmails && (0, exports.containsUrlOrEmail)(str)) {
        return { valid: false, error: exports.CONTAINS_URL_ERROR };
    }
    if ((0, exports.containsHtml)(str)) {
        return { valid: false, error: exports.CONTAINS_HTML_ERROR };
    }
    if (!config.allowTemplateBraces && (0, exports.containsTemplateBraces)(str)) {
        return { valid: false, error: "cannot contain the symbols { or }" };
    }
    return { valid: true };
};
exports.checkBasicText = checkBasicText;
var checkPageName = function (str) {
    return (0, exports.checkBasicText)(str, { allowUrlsOrEmails: true, allowTemplateBraces: true });
};
exports.checkPageName = checkPageName;
